/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {AbstractControl} from '@angular/forms';

export function objectsValidator(control: AbstractControl): object {
    if (typeof control.value === 'object' || control.value == null || control.value === '') {
        return null;
    } else {
        return {valid: false};
    }
}

